import bekat from "./assets/road.png";
import distance from "./assets/news/2.png";
import gps from "./assets/locations.png";
import logo from "./assets/logos/3-Photoroom.png-Photoroom.png";
import logo2 from "./assets/logos/4-Photoroom.png-Photoroom.png";
import qrcode from "./assets/qrcode.png";
import roadImage from "./assets/4.png";

import ModalMap from "./mapModal";
import ModalThrid from "./qrcode";
import Modalurl from "./modelUrl";
import ModalMapMain from "./map";

import locationGPS from "./assets/locationGPS.png";

function App() {
  return (
    <div
      style={{
        background: `linear-gradient(180deg, rgba(0, 62, 55, 0.67), rgba(0, 164, 146, 0.8))`,
        height: "100%",
      }}
      className="h-full">
      <br />
      <center>
        <div className="flex md:flex-row justify-between p-10 ">
          <div className=" w-full items-center">
            <img src={logo} alt="" style={{ width: "7%" }} />
            <div style={{ width: "20px" }}></div>
            <h1
              style={{ fontWeight: "600", fontSize: "26px" }}
              className="mt-5">
              ЎЗБЕКИСТОН РЕСПУБЛИКАСИ <br /> АВТОМОБИЛЬ ЙЎЛЛАРИ ҚЎМИТАСИ
            </h1>
          </div>
          {/* <div className="md:w-1/3">
            <div className="flex w-full items-center">
              <img src={logo2} alt="" style={{ width: "15%" }} />
              <div style={{ width: "20px" }}></div>
              <h1 style={{ fontWeight: "600" }}>
                AВТОМОБИЛЬ ЙЎЛЛAРИ ҚЎМИТAСИ ҲУЗУРИДАГИ АХБОРОТ - КОММУНИКАЦИЯ
                ТЕХНОЛОГИЯЛАРИНИ РИВОЖЛАНТИРИШ МАРКАЗИ ДМ
              </h1>
            </div>
          </div> */}
        </div>
      </center>
      <div className="container m-auto w-full h-full">
        <div>
          <br />
          <br />
          <div className="container mx-auto flex justify-center items-center">
            <div className="grid grid-cols-1 sm:grid-cols-5 lg:grid-cols-5 xl:grid-cols-5 gap-10 mb-10">

              <div
                className="max-w-lg overflow-hidden shadow-lg bg-white flex flex-col justify-between rounded-lg"
                style={{
                  background:
                    "linear-gradient(120deg, #5298A4, #C6D9DD, #5B8C86)",
                  borderRadius: "25px",
                  height: "510px",
                  boxShadow: "0px 0px 70px rgba(0, 62, 55, 0.8)",
                }}>
                <div className="px-6 py-4 flex-grow">
                  <div
                    className="font-bold text-xl mb-2 p-5 uppercase text-center text-black mt-5"
                    style={{
                      fontSize: "25px",
                    }}>
                    МАХСУС ТРАНСПОРТ ВОСИТАЛАРИ МОНИТОРИНГИ
                  </div>
                  <center>
                    <a href="https://smpo.uzgps.uz/login.htm">
                      <button
                        className="btn btn-green uppercase text-center m-auto rounded-lg text-white mt-5"
                        style={{
                          width: "200px",
                          height: "50px",
                          backgroundColor: "rgba(0, 164, 146, 10)",
                          fontSize: "20px",
                          fontWeight: "600",
                        }}>
                        link
                      </button>
                    </a>
                    <img
                      src={locationGPS}
                      style={{ width: "100%" }}
                      className="mt-auto rounded-xl w-full p-5"
                      alt=""
                    />
                  </center>
                </div>
              </div>
              <div
                className="max-w-lg overflow-hidden shadow-lg bg-white flex flex-col justify-between rounded-lg"
                style={{
                  background:
                    "linear-gradient(120deg, #5298A4, #C6D9DD, #5B8C86)",
                  borderRadius: "25px",
                  height: "510px",
                  boxShadow: "0px 0px 70px rgba(0, 62, 55, 0.8)",
                }}>
                <div className="px-6 py-4 flex-grow">
                  <div
                    className="font-bold text-xl mb-2 p-5 uppercase text-center text-black mt-5"
                    style={{
                      fontSize: "25px",
                    }}>
                    МАХСУС ТАРОЗИЛАР МОНИТОРИНГИ
                  </div>
                  <center>
                    <Modalurl />

                    <img
                      src={roadImage}
                      style={{ width: "100%" }}
                      className=" rounded-xl mt-5 w-full p-5"
                      alt=""
                    />
                  </center>
                </div>
              </div>
              <div
                className="max-w-sm overflow-hidden shadow-lg bg-white flex flex-col justify-between rounded-lg"
                style={{
                  background:
                    "linear-gradient(120deg, #5298A4, #C6D9DD, #5B8C86)",
                  borderRadius: "25px",
                  height: "510px",
                  boxShadow: "0px 0px 70px rgba(0, 62, 55, 0.8)",
                }}>
                <div className="px-6 py-4 flex-grow">
                  <div
                    className="font-bold text-xl mb-2 uppercase text-center text-black mt-10"
                    style={{
                      fontSize: "20px",
                    }}>
                    КАТТА ХАЖМЛИ ВА ОҒИР ВАЗНЛИ ЮКЛАРНИ ТАШИШГА РУХСАТНОМА ОЛИШ
                  </div>
                  <center>
                    <ModalThrid />
                  </center>
                </div>
                <center>
                  <img
                    src={qrcode}
                    style={{ width: "60%", marginTop: "-200px" }}
                    className="mt-auto rounded-xl w-full p-5"
                    alt=""
                  />
                </center>
              </div>
              <div
                className="max-w-sm overflow-hidden shadow-lg bg-white flex flex-col justify-between rounded-lg"
                style={{
                  background:
                    "linear-gradient(120deg, #5298A4, #C6D9DD, #5B8C86)",
                  borderRadius: "25px",
                  height: "510px",
                  boxShadow: "0px 0px 70px rgba(0, 62, 55, 0.8)",
                }}>
                <div className="px-6 py-4 flex-grow">
                  <div
                    className="font-bold text-xl mb-2 uppercase text-center text-black mt-10"
                    style={{
                      fontSize: "25px",
                    }}>
                    ХИЗМАТ КЎРСАТИШ ВА СЕРВИС МАРКАЗЛАРИ
                  </div>
                  <center>
                    <ModalMap />
                  </center>
                </div>
                <img
                  src={bekat}
                  className="mt-auto rounded-xl w-full p-5"
                  alt=""
                />
              </div>
              <div
                className="max-w-sm overflow-hidden shadow-lg bg-white flex flex-col justify-between rounded-lg"
                style={{
                  background:
                    "linear-gradient(120deg, #5298A4, #C6D9DD, #5B8C86)",
                  borderRadius: "25px",
                  height: "510px",
                  boxShadow: "0px 0px 70px rgba(0, 62, 55, 0.8)",
                }}>
                <div className="px-6 py-4 flex-grow">
                  <div
                    className="font-bold text-xl mb-2 uppercase text-center text-black mt-10"
                    style={{
                      fontSize: "25px",
                    }}>
                    ОРАЛИҚ МАСОФАНИ БЕЛГИЛАШ
                  </div>
                  <center>
                    <button
                      className="btn btn-green uppercase text-center m-auto rounded-lg text-white"
                      style={{
                        width: "200px",
                        height: "50px",
                        backgroundColor: "rgba(0, 164, 146, 10)",
                        fontSize: "20px",
                        fontWeight: "600",
                        marginTop: "70px"
                      }}
                    >
                      <a href="/monitoring"> link</a>
                    </button>
                  </center>
                </div>
                <img
                  src={gps}
                  className="mt-auto rounded-xl w-full p-5"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center"></div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
}

export default App;
